import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0A0E27] border-t border-[#1E293B] py-12" data-id="element-37" data-mp="3gg0za3iktxxn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38" data-mp="32oe1fz8zkhcr">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6" data-id="element-39" data-mp="32m1awxp5wyo3">
          <div className="text-[#94A3B8] text-sm" data-id="element-40" data-mp="36nd75m2jki59">
            © {currentYear} Justus Kraft. All rights reserved.
          </div>
          <div className="flex gap-6 text-sm text-[#94A3B8]" data-id="element-41" data-mp="38h456i9zcjd">
            <Link to="/impressum" className="hover:text-white transition-colors" data-id="element-42" data-mp="36mu4n8jl4u2">
              Legal Notice
            </Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-id="element-43" data-mp="3qc41f9dfhwkl">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}